import { useMemo, useState } from 'react'
import { SizeGuideTabButtonText } from '@components/SizeGuideTabButtonText/SizeGuideTabButtonText'
import { SansText } from '@velasca/ui/sans-text'
import {
  Row,
  SizeName,
  Tab,
  TabContent,
  Table,
  Tabs,
} from './ApparelSizeTable.styles'
import type { SizeTableProps } from './ApparelSizeTable.types'

export const ApparelSizeTable = ({
  table = { imperial: [], metric: [], sizes: [] },
  convertible,
  firstButtonText,
  secondButtonText,
  localizedSizesLabel,
  defaultMeasurementSystem,
}: SizeTableProps) => {
  const [measurementSystem, setMeasurementSystem] = useState(
    defaultMeasurementSystem,
  )
  const { [defaultMeasurementSystem]: headers, sizes: metricSizes } = table

  const imperialSizes = useMemo(() => {
    return metricSizes?.map((row) =>
      row.map((size) => {
        if (typeof size === 'string') {
          return size
        }

        return Math.round((size / 2.54) * 10) / 10
      }),
    )
  }, [metricSizes])

  const sizes = measurementSystem === 'imperial' ? imperialSizes : metricSizes

  return (
    <>
      {Boolean(convertible) && (
        <Tabs>
          <Tab
            isSelected={measurementSystem === 'imperial'}
            order={defaultMeasurementSystem === 'metric' ? 0 : 1}
            onClick={() => {
              setMeasurementSystem('metric')
            }}
          >
            <SizeGuideTabButtonText>{firstButtonText}</SizeGuideTabButtonText>
          </Tab>
          <Tab
            isSelected={measurementSystem === 'metric'}
            order={defaultMeasurementSystem === 'imperial' ? 0 : 1}
            onClick={() => {
              setMeasurementSystem('imperial')
            }}
          >
            <SizeGuideTabButtonText>{secondButtonText}</SizeGuideTabButtonText>
          </Tab>
        </Tabs>
      )}
      <TabContent convertible={convertible}>
        <Table>
          {/* Prints header rows */}
          {headers?.map((header, i) => (
            <Row
              key={`header-${i}`}
              nColumn={header.length}
              convertible={convertible}
            >
              {header.map((unitMeasureCell, j) => (
                <SizeName key={`${unitMeasureCell}-${i}-${j}`}>
                  <SansText center fontWeight="500" color="primary">
                    {unitMeasureCell === 'localizedSizesLabel'
                      ? localizedSizesLabel
                      : unitMeasureCell}
                  </SansText>
                </SizeName>
              ))}
            </Row>
          ))}

          {/* Prints body rows */}
          {sizes.map((row, i) => (
            <Row
              key={`size-${i}`}
              nColumn={row.length}
              convertible={convertible}
            >
              {row.map((cell, j) => {
                if (typeof cell === 'string') {
                  return (
                    <SizeName key={`${cell}-${i}-${j}`}>
                      <SansText center fontWeight="600">
                        {cell}
                      </SansText>
                    </SizeName>
                  )
                }

                return (
                  <SansText center key={`${cell}-${i}-${j}`}>
                    {cell}
                  </SansText>
                )
              })}
            </Row>
          ))}
        </Table>
      </TabContent>
    </>
  )
}
